import { Button } from '@ibsys/kit';
import { ChangeEvent, FC, useRef } from 'react';
import { Icon } from '../Icon';

type Props = {
  file: File | null;
  accept?: string;
  label: string;
  onChange: (file: File | null) => void;
};

export const FileButton: FC<Props> = ({ file, accept, label, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0];
    if (selected) onChange(selected);
  };

  const handleRemove = () => {
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  if (file) {
    return (
      <div className="flex items-center gap-2">
        <span className="text-sm text-foreground">{file.name}</span>
        <Button variant="ghost" size="icon" onClick={handleRemove} aria-label="Удалить файл">
          <Icon type="close" />
        </Button>
      </div>
    );
  }

  return (
    <>
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handleFileChange} />
      <Button variant="outline" onClick={() => inputRef.current?.click()}>
        {label}
      </Button>
    </>
  );
};
